"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var Field_1 = __importDefault(require("../../components/Field"));
var utils_1 = require("../SpecializaceField/utils");
var SelectJSpecializace_1 = __importDefault(require("./SelectJSpecializace"));
var FieldWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 1em;\n"], ["\n  margin-top: 1em;\n"])));
var VyhledavaniSpecializaceField = function (_a) {
    var _b;
    var name = _a.name, defaultSelect = _a.defaultSelect, enableReset = _a.enableReset, showLabel = _a.showLabel, placeholder = _a.placeholder;
    var _c = formik_1.useField(name), field = _c[0], helpers = _c[2];
    var _d = hooks_1.useCiselnik('specializaceVcetneNeplatnych'), data = _d.data, loading = _d.loading, error = _d.error;
    var _e = react_1.useState(), defaultOption = _e[0], setDefaultOption = _e[1];
    react_1.useEffect(function () {
        if (defaultSelect && (data === null || data === void 0 ? void 0 : data.length)) {
            if (defaultSelect.value) {
                var spec = utils_1.getJSpecializaceById(defaultSelect.value, data || []);
                if (spec)
                    setDefaultOption({ selected: spec.id, option: { value: spec === null || spec === void 0 ? void 0 : spec.id, label: spec === null || spec === void 0 ? void 0 : spec.nazev } });
            }
            helpers.setValue({ specializace: defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.value });
        }
    }, [defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.value, data]);
    if (loading) {
        return (react_1.default.createElement(Field_1.default, null,
            react_1.default.createElement("div", null, "na\u010D\u00EDt\u00E1n\u00ED")));
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    return (react_1.default.createElement(FieldWrapper, null,
        react_1.default.createElement(SelectJSpecializace_1.default, { label: showLabel ? 'Specializace' : '', name: name, onChange: function (o) { return helpers.setValue({ specializace: o }); }, value: (_b = field.value) === null || _b === void 0 ? void 0 : _b.specializace, defaultOption: defaultOption, enableReset: enableReset, placeholder: placeholder })));
};
VyhledavaniSpecializaceField.defaultProps = {
    defaultSelect: undefined,
    enableReset: undefined,
    showLabel: true,
    placeholder: undefined,
};
exports.default = VyhledavaniSpecializaceField;
var templateObject_1;
